// @flow
import * as React from 'react';
import Hero from 'components/Hero';
import { H1, H2 } from 'components/Text';
import Flex from 'components/Flex';
import Box from 'components/Box';
import type { CtaHeroBlockData } from 'api/cms';
import { TrackedPrimaryButtonLink } from 'components/Button';

const CallToActionHeroBlock = ({
  data: { buttonText, buttonUrl, text, image },
  isPageHeader,
  parallax,
  blockIndex,
  pageUpdated
}: {
  data: CtaHeroBlockData,
  isPageHeader?: boolean,
  parallax?: boolean,
  blockIndex: number,
  pageUpdated: string
}) => {
  const Heading = isPageHeader ? H1 : H2;
  return (
    <Hero
      withOverlay
      heroImage={image}
      data-qa-id="call-to-action-hero"
      parallax={parallax}
      minHeight="calc(100vh - 300px)"
    >
      <Box maxWidth="768px" m="0 auto" px="20px">
        <Heading
          mt={['48px', '48px', '48px', '80px']}
          mb={['18px', '18px', '18px', '42px']}
          color="white"
          textAlign="center"
        >
          {text}
        </Heading>
      </Box>
      <Flex>
        {buttonUrl && buttonText && (
          <TrackedPrimaryButtonLink
            href={buttonUrl}
            eventName="CMS Block"
            eventProperties={{
              block_position: blockIndex,
              block_type: 'Call to Action Hero',
              cta_type: 'Button',
              button_text: buttonText,
              page_updated: pageUpdated
            }}
          >
            {buttonText}
          </TrackedPrimaryButtonLink>
        )}
      </Flex>
    </Hero>
  );
};

export default CallToActionHeroBlock;
